import { Link } from "@tanstack/react-router";
import { ArrowLeft } from "lucide-react";
import { logo } from "@/assets";

interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  footer?: React.ReactNode;
}

function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className="flex min-h-[var(--visual-vh,100vh)] flex-col items-center overflow-y-auto bg-paper px-5 py-12 md:justify-center">
      <div className="w-full max-w-[420px]">
        <div className="mb-5">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-[13px] text-slate transition-colors hover:text-ink"
          >
            <ArrowLeft className="size-3.5" />
            Go back
          </Link>
        </div>

        <div className="mb-8 flex flex-col items-center gap-3">
          <img src={logo} alt="" className="block size-12 object-contain" />
          <span className="font-display text-[22px] font-semibold tracking-[-0.015em] text-ink">
            Slotique
          </span>
        </div>

        <div className="rounded-lg border border-fog bg-surface px-6 py-7 shadow-soft1">
          <div className="mb-6 text-center">
            <h1 className="font-display text-[22px] font-semibold tracking-[-0.01em] text-ink">
              {title}
            </h1>
            {subtitle && <p className="mt-1.5 text-[14px] text-slate">{subtitle}</p>}
          </div>

          {children}
        </div>

        {footer && <div className="mt-6 text-center text-[14px] text-slate">{footer}</div>}
      </div>
    </div>
  );
}

export { AuthLayout, type AuthLayoutProps };
